import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
import Catalogs from '../catalogs'
const model = (payload) => ({
  id: payload.id
})
var crud = new Crud('PurchaseOrderProducts', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  purchaseOrderProducts: []
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  SET_RECORDS (state, payload) {
    state.purchaseOrderProducts = payload.data

    state.pagination = {
      currentPage: payload.meta.current_page,
      perPage: payload.meta.per_page,
      totalUsers: payload.meta.total,
      totalPages: payload.meta.last_page
    }
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  async loadRecords ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-order-details/formated-products?page=${payload.page}${this.getters['PurchaseOrderProducts/filterParams']}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  exportRecords ({ commit }) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/purchase-order-details/export-view-products?format=csv${this.getters['PurchaseOrderProducts/filterParams']}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  purchaseOrderProducts: state => state.purchaseOrderProducts
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
